import { render, staticRenderFns } from "./orderRemark.vue?vue&type=template&id=fdfe19ce&scoped=true"
import script from "./orderRemark.vue?vue&type=script&lang=js"
export * from "./orderRemark.vue?vue&type=script&lang=js"
import style0 from "./orderRemark.vue?vue&type=style&index=0&id=fdfe19ce&prod&scoped=true&lang=css"
import style1 from "./orderRemark.vue?vue&type=style&index=1&id=fdfe19ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe19ce",
  null
  
)

export default component.exports